var isMobile = window.innerWidth <= 980;

function wapPageInit() {

  //注册图片懒加载
  new LazyLoad({
    elements_selector: "#MainContent img",
    data_src: "cbcn-src",
    data_srcset: "cbcn-srcset",
    threshold: "1000",
    callback_enter: function (element) {},
  });
  new LazyLoad({
    elements_selector: "#MainContent video",
    data_src: "cbcn-src",
    data_srcset: "cbcn-srcset",
    data_poster: "cbcn-poster",
    threshold: "1000",
    callback_enter: function (element) {},
  });

  // 移动端横屏问题
  var refreshTimer = null;
  // 或者监听设备方向的变化
  window.addEventListener("orientationchange", () => {
    // let orientation = screen.orientation || window.orientation;
    // if (orientation.type.includes('portrait')) {
    //   // 竖屏
    //   console.log('现在是竖屏');
    // } else if (orientation.type.includes('landscape')) {
    //   // 横屏
    //   console.log('现在是横屏');
    // }

    refreshTimer = this.clearTimeout(refreshTimer);
    setTimeout(ScrollTrigger.refresh, 200);
  });

  // 视频轮播 001 start
new Swiper(".jp-banner-swiper", {
    spaceBetween: 30,
    centeredSlides: true,
    
    pagination: {
        el: ".banner-slider .swiper-pagination",
        clickable: true, // 改为 true，让用户可以点击切换
    },
    
    navigation: {
        nextEl: ".banner-slider .swiper-button-next",
        prevEl: ".banner-slider .swiper-button-prev",
    },
    
    // 视频处理事件
    on: {
        // 切换幻灯片时
        slideChange: function () {
            var self = this;
            
            // 暂停所有视频
            var allVideos = document.querySelectorAll('.jp-banner-swiper video');
            allVideos.forEach(function(video) {
                video.pause();
            });
            
            // 播放当前幻灯片的视频
            setTimeout(function() {
                var activeSlide = self.slides[self.activeIndex];
                if (activeSlide) {
                    var activeVideo = activeSlide.querySelector('video');
                    if (activeVideo) {
                        activeVideo.currentTime = 0;
                        activeVideo.play().catch(function() {
                            // 静默处理播放失败（autoplay 会兜底）
                        });
                    }
                }
            }, 150);
        },
        
        // 初始化时播放第一个视频
        init: function() {
            var self = this;
            setTimeout(function() {
                var firstSlide = self.slides[self.activeIndex];
                if (firstSlide) {
                    var firstVideo = firstSlide.querySelector('video');
                    if (firstVideo) {
                        firstVideo.play().catch(function() {
                            // 静默处理
                        });
                    }
                }
            }, 150);
        }
    }
});

  // 视频轮播 002 end


  // 产品轮播 begin

     new Swiper('.product-swiper', {
            // Optional parameters
            direction: 'horizontal',

            effect: 'slide',
            speed: 800,
            
            // Responsive breakpoints
            breakpoints: {
                // When window width is >= 768px
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                // When window width is >= 1024px
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 40
                }
            },

            // Pagination
            pagination: {
                el: '.product-pagination',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.product-next',
                prevEl: '.product-prev',
            },

      });


  // 产品轮播 end


  //  family begin

        new Swiper('.family', {
            direction: 'horizontal',
            speed: 800,
            
            // 响应式断点
            breakpoints: {
                320: {
                    spaceBetween: 30,
                    slidesPerView: 1,
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: 2,
                },
                1024: {
                    spaceBetween: 30,
                    slidesPerView: 3,
                },
            },

            // Pagination
            pagination: {
                el: '.ok',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.family-next',
                prevEl: '.family-prev',
            },
        });
  //  family end






//lucida begin

        new Swiper('.lucidawap', {
            direction: 'horizontal',
            speed: 800,
            
            // 响应式断点
            breakpoints: {
                320: {
                    spaceBetween: 30,
                    slidesPerView: 1,
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: 2,
                },
                1024: {
                    spaceBetween: 30,
                    slidesPerView: 3,
                },
            },

            // Pagination
            pagination: {
                el: '.lucidawapok',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.lucidawap-next',
                prevEl: '.lucidawap-prev',
            },
        });



//lucida end


//logoitem begin

    new Swiper('.logoitem', {
        direction: 'horizontal',
        effect: 'fade',
        speed: 800,
        
        // fade 效果只能显示一个幻灯片
        slidesPerView: 1,
        spaceBetween: 0,
        
        // fade 效果配置
        fadeEffect: {
            crossFade: true
        },
        

    
        // Navigation arrows
        navigation: {
            nextEl: '.logoitem-next',
            prevEl: '.logoitem-prev',
        },
    });

        
//logoitem end

//fair begin

        new Swiper('.fairwap', {
            direction: 'horizontal',
            speed: 800,
            
            // 响应式断点
            breakpoints: {
                320: {
                    spaceBetween: 30,
                    slidesPerView: 1,
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: 1,
                },
                1024: {
                    spaceBetween: 30,
                    slidesPerView: 3,
                },
            },

            // Pagination
            pagination: {
                el: '.fairokwap',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.fairwap-next',
                prevEl: '.fairwap-prev',
            },
        });




//fair end


//// 第十个   begin 

new Swiper('.promisewap', {
            direction: 'horizontal',
            speed: 800,
            
            // 响应式断点
            breakpoints: {
                320: {
                    spaceBetween: 30,
                    slidesPerView: 1,
                },
                768: {
                    spaceBetween: 30,
                    slidesPerView: 2,
                },
                1024: {
                    spaceBetween: 30,
                    slidesPerView: 3,
                },
            },

            // Pagination
            pagination: {
                el: '.promisewap-pagination',
                clickable: true,
                dynamicBullets: false,
            },

            // Navigation arrows
            navigation: {
                nextEl: '.promisewap-next',
                prevEl: '.promisewap-prev',
            },
});


//// 第十个 end 








}

if (isMobile) {
  window.onload = function () {
    wapPageInit();
  };
}